var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{attrs:{"gutter":10}},[_c('el-col',{staticStyle:{"width":"200px"}},[_c('el-card',{staticClass:"box-card",attrs:{"shadow":"never"}},[_c('side',{ref:"side",staticClass:"side",attrs:{"list":_vm.userMenu}})],1)],1),_c('el-col',{staticStyle:{"width":"calc(100% - 200px)"}},[_c('div',{staticClass:"user_right"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }